import React, { useEffect, useState } from "react";
import TableLoading from "../components/Shared/TableLoading";
import { useTranslation } from "react-i18next";
import CustomTable from "../components/Shared/CustomTable";
import supergitHIS from "../api/supergitHIS";
import CustomPagination from "../components/Shared/CustomPagination";
import { FaEye, FaPrint } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";

import { useNavigate } from "react-router-dom";
import CustomTabs from "../components/Shared/CustomTabs";
import StoreInvoicesMain from "./StoreInvoicesMain";
import RevokeStoreInvocies from "./RevokeStoreInvocies";

function ThirdPartyB2b({ activeTab }) {
  const { t } = useTranslation();

  const storeInvoicesTabs = (t) => {
    return [
      {
        name: t("invoices"),
        content: <StoreInvoicesMain activeTab={activeTab} />,
      },
      // {
      //   name: t("revoke_invoices"),
      //   content: <RevokeStoreInvocies activeTab={activeTab} />,
      // },
      {
        name: t("Credit Notes"),
        content: <RevokeStoreInvocies activeTab={activeTab} />,
      },
    ];
  };

  return (
    <div>
      <CustomTabs tabs={storeInvoicesTabs(t)} />
    </div>
  );
}

export default ThirdPartyB2b;
